module.exports = "<md-icon class=icon-signal md-svg-icon=\"{{ $ctrl.radioIcon }}\" aria-label=Signal></md-icon>";


//////////////////
// WEBPACK FOOTER
// ./app/common/radio-status/radio-status.html
// module id = mpcD
// module chunks = 1